import { scrollToHash } from "./Header";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[var(--sp-line)] bg-[var(--sp-surface)] text-[var(--sp-fg)]">
      <div className="mx-auto max-w-[1500px] px-5 pb-10 pt-16 sm:px-8 lg:pt-24">
        <a
          href="#top"
          onClick={(e) => scrollToHash(e, "#top")}
          data-testid="footer-logo-link"
          className="block font-display text-[13vw] font-black uppercase leading-[0.85] tracking-tight lg:text-[9rem]"
        >
          Shady<span className="text-[var(--sun)]">Parking</span>
        </a>
        <div className="mt-10 grid grid-cols-1 gap-8 border-t border-[var(--sp-line)] pt-8 md:grid-cols-3">
          <div>
            <p className="font-mono2 text-[10px] uppercase tracking-[0.14em] text-[var(--sp-faint)]">System</p>
            <ul className="mt-3 space-y-2">
              {[
                ["Mission", "#mission", "footer-link-mission"],
                ["Growth Path", "#growth-path", "footer-link-growth-path"],
                ["Reporting Engine", "#engine", "footer-link-engine"],
                ["Simulator", "#simulator", "footer-link-simulator"],
              ].map(([label, href, id]) => (
                <li key={href}>
                  <a
                    href={href}
                    data-testid={id}
                    onClick={(e) => scrollToHash(e, href)}
                    className="font-mono2 text-xs uppercase tracking-[0.18em] text-[var(--sp-muted)] transition-colors hover:text-[var(--sun)]"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono2 text-[10px] uppercase tracking-[0.14em] text-[var(--sp-faint)]">Telemetry · Sample</p>
            <p className="mt-3 font-mono2 text-xs leading-relaxed tracking-[0.1em] text-[var(--sp-muted)]">
              SOLAR ELEV 41.7° · AZIMUTH 212°
              <br />
              SHADOW INDEX 0.83 · ILLUSTRATIVE VALUES
            </p>
          </div>
          <div>
            <p className="font-mono2 text-[10px] uppercase tracking-[0.14em] text-[var(--sp-faint)]">Guarantee</p>
            <p className="mt-3 font-mono2 text-xs leading-relaxed tracking-[0.1em] text-[var(--sp-muted)]">
              No account required. No tracking.
              <br />
              Your privacy is preserved.
            </p>
          </div>
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-between gap-4 border-t border-[var(--sp-line)] pt-6">
          <p className="font-mono2 text-[10px] uppercase tracking-[0.14em] text-[var(--sp-faint)]">
            © 2026 ShadyParking.Space — All shade reserved
          </p>
          <p className="font-mono2 text-[10px] uppercase tracking-[0.14em] text-[var(--sp-faint)]">
            The world's first comfort-zone finder
          </p>
        </div>
      </div>
    </footer>
  );
}
